/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import VideoLayout from './layouts/VideoLayout';
import GenericPage from './pages/Generic/GenericPage';
import Login from './pages/login/Login';
import PageNotFound from './pages/pageNotFound/PageNotFound';
import PasswordReset from './pages/passwordReset/PasswordReset';
import RedirectMFAPage from './pages/RedirectMFA/redirectMFA';
import SamlLogin from './pages/saml/Saml';
import { getTree } from './utils/FRCallBackUtil';
const App: React.FC = () => {
  return (
    <>
   <BrowserRouter basename='oneportal'>
      <Routes>
        <Route element={<VideoLayout />}>
          <Route path="/login" element={<Login queryParams={["appName"]}/>} />
          <Route path="/reset-password" element={<PasswordReset />} />
          <Route path="/samlLogin" element={<SamlLogin/>} />
          <Route path="/setPassword" element={<GenericPage tree={getTree('PasswordSet')} queryParams={['resumeCode']}  />} />
          <Route path="/" element={<PageNotFound />} />
          <Route path="/redirectMFA" element={<RedirectMFAPage/>}/>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </>
  );
};

export default App;
